<template>
  <div>
    <div v-html="content.text.text_investors_geography_title"></div>
    <div class="investors-geography">
      <div class="investors-geography__item" v-for="(geography, key1) in investorsGeographies.item">
        <div class="investors-geography__item-img">
          <img :src="geography.photo.$src" alt="" :style="`animation-delay: ${(key1 * 100)/1000}s`"/>
        </div>
        <div class="investors-geography__item-percent">
          <span class="percents" :class="{'percents_double': String(geography.$percents).length > 1}">
            <span class="percents__line" v-if="String(geography.$percents)[0]">
              <span class="percents__num" v-if="key >= parseInt(String(geography.$percents)[0], 10)" v-for="ind, key in rand">
                {{ key }}
              </span>
            </span> 
            <span class="percents__line" v-if="String(geography.$percents)[1] > 0">
              <span class="percents__num" v-if="rand.length - key2 >= parseInt(String(geography.$percents)[1], 10)" v-for="ind2, key2 in rand">
                {{ rand.length - key2 }}
              </span>
            </span>
            <span class="percents__line" v-else>
              <span class="percents__num">
                {{ String(geography.$percents)[1] }}
              </span>
            </span>
          </span><span class="percents__sign">
            <span>%</span>
          </span>
        </div>
        <div class="investors-geography__item-title">{{ geography.text.item.title }}</div>
      </div>
    </div>
    <div v-html="content.text.text_investors_types_title"></div>
    <div class="investors-types" :class="{'animated': typesAnimation}">
      <div class="investors-types__item" v-for="(type, key) in investorsTypes.item">
        <div class="investors-types__item-title">
          <span :style="`animation-delay: ${(key * 100)/1000}s`">
            {{ type.text.item.title }}
          </span>
        </div>
        <div class="investors-types__item-value" :style="`animation-delay: ${((key + 1) * 170)/1000}s`">
          <span>
            <span :style="{ width: type.$percents + '%' }"></span>
          </span>
        </div>
        <div class="investors-types__item-number">
          <span :style="`animation-delay: ${((key + 1) * 300)/1000}s`">{{ type.$percents }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'investors',
    props: ['content'],
    computed: mapGetters({
      lang: 'lang',
      investorsTypes: 'investorsTypes',
      investorsGeographies: 'investorsGeographies',
    }),
    data() {
      return {
        rand: [],
        typesAnimation: false,
      };
    },
    watch: {
      lang() {
        this.getData();
      },
    },
    methods: {
      getData() {
        this.$store.dispatch('fetchInvestorsTypes', { lang: this.lang, $http: this.$http });
        this.$store.dispatch('fetchInvestorsGeographies', { lang: this.lang, $http: this.$http });
      },
    },
    mounted() {
      this.rand.length = 9;
      this.getData();
      setTimeout(() => {
        this.typesAnimation = !this.typesAnimation;
      }, 3000);
    },
  };
</script>

<style scoped>
  @keyframes scaleCountry {
    0%   {
      transform: scale(0) translate3d(-50%, -50%, 0) rotate(45deg);
    }
    100% { 
      transform: scale(1) translate3d(-50%, -50%, 0) rotate(0);
    }
  }

  @keyframes rollNumbers {
    0%   {
      transform: translateY(-100%);
    }
    100% { 
      transform: translateY(0);
    }
  }

  @keyframes rollNumbers2 {
    0%   {
      transform: translateY(0);
    }
    100% { 
      transform: translateY(-100%);
    }
  }

  @keyframes percentAnimation {
    0%   {
      transform: translateY(100%);
    }
    100% { 
      transform: translateY(0%);
    }
  }

  @keyframes typeLineAnimation {
    0%   {
      width: 0;
    }
    100% { 
      width: 100%;
    }
  }

  .percents {
    display: inline-block;
    vertical-align: top;
    height: 50px;
    position: relative;
    width: 30px;
    overflow: hidden;

    &_double {
      width: 60px;
    }

    &__line {
      position: absolute;
      left: 30px;
      top: 100%;
      transform: translateY(0);

      & > span {
        height: 50px;
      }

      .tabs__content.selected & {
        animation: rollNumbers2 1.5s cubic-bezier(0.500, 0.000, 0.100, 1.000) forwards;
      }
    }

    .percents__line:first-child {
      left: 0;
      top: 0;
      transform: translateY(-100%);

      .tabs__content.selected & {
        animation: rollNumbers 1.5s cubic-bezier(0.500, 0.000, 0.100, 1.000) forwards;
      }
    }

    &__num {
      display: block;
    }

    &__sign {
      display: inline-block;
      overflow: hidden;
      height: 50px;

      span {
        display: inline-block;
        transform: translateY(100%);
        animation: percentAnimation 0.9s cubic-bezier(0.500, 0.000, 0.100, 1.000) 0.7s forwards;
      }
    }
  }

  .investors-geography {
    margin: 0 0 50px -20px;
    text-align: center;

    &__item {
      display: inline-block;
      vertical-align: top;
      text-align: left;
      padding: 30px 50px;
      width: 20%;
      font-size: 0;
      margin-bottom: 70px;
      min-width: 220px;
      min-height: 100px;
      position: relative;
      z-index: 1;

      &-img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: -1;

        img {
          width: 90%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: scale(0) translate3d(-50%, -50%, 0) rotate(45deg);
          transform-origin: top left;

          .tabs__content.selected & {
            animation: scaleCountry 0.7s cubic-bezier(0.645, 0.045, 0.230, 0.915) forwards;
          }
        }
      }

      &-title {
        font-size: 18px;
      }

      &-percent {
        height: 50px;
        font-size: 50px;
        line-height: 100%;
      }
    }
  }

  .investors-types {
    width: 80%;

    &__item {
      margin-bottom: 15px;

      & > div {
        display: inline-block;
        vertical-align: top;
      }

      &-title {
        width: 30%;
        padding-right: 15px;
        overflow: hidden;
        min-width: 115px;

        span {
          display: inline-block;
          transform: translateY(100%);
        }
      }

      &-value {
        width: 54%;
        height: 4px;
        background: #d4e3ec;
        position: relative;
        top: 9px;

        & > span {
          width: 0;

          span {
            position: absolute;
            top: 0;
            left: 0;
            background: $main-color;
            height: 100%;
            display: inline-block;
          }
        }
      }

      &-number {
        font-family: 'UniversLTStdBold';
        width: 14%;
        padding-left: 15px;
        overflow: hidden;
        min-width: 55px;

        span {
          display: inline-block;
          transform: translateY(100%);
        }
      }
    }

    &.animated {
      .investors-types__item {
        &-title {
          span {
            animation: percentAnimation 0.5s cubic-bezier(0.500, 0.000, 0.100, 1.000) forwards;
          }
        }

        &-value {
          & > span {
            animation: typeLineAnimation 0.8s cubic-bezier(0.600, 0.085, 0.050, 0.895) forwards;
          }
        }

        &-number {
          span {
            animation: percentAnimation 0.5s cubic-bezier(0.500, 0.000, 0.100, 1.000) forwards;
          }
        }
      }
    }
  }

  @media (max-width: 850px){
    .investors-types {
      width: 100%;

      &__item {
        &-value {
          width: 32%;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Investors.vue?85f59b34